import React, { FC } from "react";
import { COLOR_GREY_6 } from "../colors";
import { IconType } from "./types";

export const PuzzleIcon: FC<IconType> = ({ color = COLOR_GREY_6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M18.8421 10.4211V8.1579C18.8421 6.50104 17.4988 5.15789 15.8419 5.15789C14.8782 5.15789 13.9609 5.15789 13.5789 5.15789C13.5789 3.41684 12.1621 2 10.4211 2C8.68 2 7.26316 3.41684 7.26316 5.15789C6.88118 5.15789 5.96389 5.15789 5.00016 5.15789C3.34331 5.15789 2 6.50104 2 8.1579V11.4737H3.05263C3.61098 11.4737 4.14646 11.6955 4.54128 12.0903C4.93609 12.4851 5.15789 13.0206 5.15789 13.5789C5.15789 14.1373 4.93609 14.6728 4.54128 15.0676C4.14646 15.4624 3.61098 15.6842 3.05263 15.6842H2V19C2 20.6569 3.34299 22 4.99984 22C6.39168 22 7.84244 22 8.31579 22V20.9474C8.31579 20.389 8.53759 19.8535 8.93241 19.4587C9.32722 19.0639 9.8627 18.8421 10.4211 18.8421C10.9794 18.8421 11.5149 19.0639 11.9097 19.4587C12.3045 19.8535 12.5263 20.389 12.5263 20.9474V22C12.9997 22 14.4504 22 15.8423 22C17.4991 22 18.8421 20.6569 18.8421 19V16.7368C20.5832 16.7368 22 15.32 22 13.5789C22 11.8379 20.5832 10.4211 18.8421 10.4211Z"
      fill={color}
    />
  </svg>
);
